/* eslint-disable jsx-a11y/anchor-is-valid */
import { useEffect, useState, useCallback, useRef } from "react";
import { Select, Input, Button } from "antd";
import { _get, _post } from "../../Utils/Helper";
import PDFTEMPLATE from "./components/PDFTEMPLATE";
import { PDFDownloadLink, PDFViewer } from "@react-pdf/renderer";
import { Link } from "react-router-dom";
import { all_routes } from "../../router/all_routes";
import { RootState } from "../../../redux/reducers";
import { useSelector } from "react-redux";
import { Table } from "react-bootstrap";
import CommonSelect, { Option } from "../../../core/common/commonSelect";
import { acadamicTerms, category } from "../../../core/common/selectoption/selectoption";
import { SingleValue } from "react-select";
import MergedPDFTemplate from "./components/MergedPDFTemplate";
import { SwatchBook } from "lucide-react";
import { toast } from "react-toastify";

// const { Option } = Select;

interface SubjectDetail {
  name: string;
  caScore?: string;
  examScore?: string;
  assignmentScore?: string;
  grade?: string;
  mark_by?: string;
}

interface StudentData {
  student_name: string;
  admission_no: string;
  class_name: string;
  academic_year: string;
  term: string;
  total_score: number;
  remark: string;
  result: string;
  [subject: string]: SubjectDetail | string | number | undefined;
}

const GenerateReport = () => {
  const _form = {
    query_type: "Select Class Reports",
    term: "",
    class_name: "",
    academic_year: "",
    school_id: ""
  }
  const _behavioralForm = {
    grade: "",
    description: "",
    admission_no: ''
  }
  const { classes, school, user } = useSelector((state: RootState) => (state.auth))
  const [admissionNo, setAdmissionNo] = useState<string>('');
  const [studentName, setStudentName] = useState<string>('');
  const [studentData, setStudentData] = useState<any[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [form, setForm] = useState(_form)
  const [showForm, setShowForm] = useState(false)
  const [behavioralTraits, setBehavioralTraits] = useState([])
  const [behavioralForm, setBehavioralForm] = useState(_behavioralForm)
  const [behavioralData, setBehavioralData] = useState<{ grade: string; description: string; admission_no: string, category: string }[]>([])
  const [selectedGrades, setSelectedGrades] = useState<Record<string, SingleValue<Option>>>({});
  const [academicCalendar, setAcademicCalendar] = useState<any[]>([]);

  useEffect(() => {
    if (school && school.school_id) {
      setForm((p) => ({ ...p, school_id: school.school_id, academic_year: school.academic_year, term: school.term }))
    }
  }, [school.school_id])

  const fetchStudentData = () => {
    setIsLoading(true);
    _post(
      `get_class_results`,
      form,
      (res) => {
        if (res && res.success) {
          setStudentData(res.results);

        }
        setIsLoading(false);
      },
      (err) => {
        console.error("Error fetching student details:", err);
        setIsLoading(false);
      }
    );
    _post(
      `character-scores`,
      {
        query_type: 'Select School Characters',
        school_id: school.school_id
      },
      (res) => {
        if (res && res.success) {
          setBehavioralTraits(res.results);
        }
        setIsLoading(false);
      },
      (err) => {
        console.error("Error fetching  details:", err);
        setIsLoading(false);
      }
    );

  }
  const handleSubmitTrait = (e: any) => {
    e.preventDefault()
    const data = behavioralData.map(x => ({
      ...x,
      school_id: school.school_id,
      query_type: 'insert',
      academic_year: school.academic_year,
      class_name: form.class_name,
      term: form.term,
      created_by: user.id,
      student_name: studentName,
    }))
    _post(
      `new-character-scores`,
      data,
      (res) => {
        if (res && res.success) {
          // setBehavioralTraits(res.results);
          setBehavioralData([])
          setBehavioralForm(_behavioralForm)
          toast.success('Submitted')
        }
        setIsLoading(false);
      },
      (err) => {
        console.error("Error fetching  details:", err);
        setIsLoading(false);
      }
    );
  }
  // const handleChange = (e: any) => {
  //   setForm((p) => ({ ...p, [e.target.name]: e.target.value }));
  // };

  const transformStudentData = (
    data: StudentData[]
  ): Record<string, StudentData[]> => {
    return data?.reduce((groups: Record<string, StudentData[]>, item: StudentData) => {
      const key = `${item.student_name}: ${item.admission_no}`;
      if (!groups[key]) {
        groups[key] = [];
      }
      groups[key].push(item);
      return groups;
    }, {} as Record<string, StudentData[]>);
  };

  const groupedResults = transformStudentData(studentData);
  useEffect(() => {
    if (school && school.school_id) {
      setForm((p) => ({ ...p, school_id: school.school_id, academic_year: school.academic_year, term: school.term }))
    }
  }, [school.school_id])
  useEffect(() => {
    if (academicCalendar && academicCalendar.length) {
      setAcademicCalendar(academicCalendar)
    }
  }, [academicCalendar])

  return (
    <div>
      <div className="page-wrapper">
        <div className="content">
          <div className="d-md-flex d-block align-items-center justify-content-between mb-3">
            <div className="my-auto mb-2">
              <h3 className="page-title mb-1">Generate Report</h3>

            </div>
            <PDFViewer>
              <PDFTEMPLATE student={studentData} school={school} grading={[]} scores={[]} academic_calendar={academicCalendar} />
            </PDFViewer>
            <nav>
              <ol className="breadcrumb mb-0">
                <li className="breadcrumb-item">
                  <Link to="/dashboard">Dashboard</Link>
                </li>
                <li className="breadcrumb-item">
                  <Link to="#">Exam</Link>
                </li>
                <li className="breadcrumb-item active" aria-current="page">
                  Student Exam Report
                </li>
              </ol>
            </nav>
          </div>

          <div className="d-flex justify-content-around mb-3">
            {/* <div>
              <label>Select Section  </label>
              <CommonSelect
                placeholder="Select Class"
                defaultValue={{ label: form.class_name, value: form.class_name }}
                options={classes.map((classItem: any) => ({
                  label: classItem.class_name, value: classItem.class_name
                }))}
                handleChange={(newValue: SingleValue<Option>) =>
                  setForm((prev) => ({
                    ...prev,
                    class_name: newValue ? newValue.value : "",
                  }))
                }
              />
            </div> */}
            <div>
              <label>Select Class </label>
              <CommonSelect
                placeholder="Select Class"
                defaultValue={{ label: form.class_name, value: form.class_name }}
                options={classes.map((classItem: any) => ({
                  label: classItem.class_name, value: classItem.class_name
                }))}
                handleChange={(newValue: SingleValue<Option>) =>
                  setForm((prev) => ({
                    ...prev,
                    class_name: newValue ? newValue.value : "",
                  }))
                }
              />
            </div>

            <div>
              <label>Select Term</label>
              <CommonSelect
                placeholder="Select Term"
                className="select"
                options={acadamicTerms}
                defaultValue={{
                  label: form.term,
                  value: form.term,
                }}
                handleChange={(newValue: SingleValue<Option>) =>
                  setForm((prev) => ({
                    ...prev,
                    term: newValue ? newValue.value : "",
                  }))
                }
              />
            </div>
            <div className="pt-4">
              <Button type="primary" onClick={fetchStudentData} loading={isLoading}>
                Generate Report
              </Button>
            </div>
          </div>
          <table className="table mt-4">
            <thead>
              <tr>
                <th>#</th>
                <th>Student Name</th>
                <th>Admission No.</th>
                <th>Action</th>
              </tr>
            </thead>
{/* <pre>{JSON.stringify(studentData)}</pre> */}
            {studentData.length > 0 && (
              <tbody>
                {Object.entries(groupedResults).map(
                  ([key, sdtData]: [string, StudentData[]], index: number) => (
                    <tr key={key}>
                      <td>{index + 1}</td>
                      <td>{sdtData[0].student_name}</td>
                      <td>{sdtData[0].admission_no}</td>
                      <td>
                        <Button
                          onClick={() => { setAdmissionNo(sdtData[0].admission_no); setStudentName(sdtData[0].student_name) }}
                          data-bs-toggle="modal"
                          data-bs-target="#preview-modal"
                        >
                          Preview
                        </Button>
                      </td>
                    </tr>
                  )
                )}
              </tbody>
            )}
          </table>
        </div>
      </div>
      <div className="modal fade" id="preview-modal">
        <div className="modal-dialog modal-dialog-centered modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title">{studentData[0]?.class_name}EXAM SCORES {studentData[0]?.academic_year} - {studentData[0]?.term} : {studentName} ({admissionNo}) </h4>
              <button
                type="button"
                className="btn-close custom-btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <i className="ti ti-x" />
              </button>
            </div>
            <div className="row">
              <div className="col-md-12">
                <div className="accordion-body">
               
                  <div className="table-responsive">
                    <table className="table">
                      <thead className="thead-light">
                        <tr>
                          <th>Subject</th>
                          <th>Score</th>
                          <th>Grade</th>
                          <th>Remark</th>
                        </tr>
                      </thead>
                      <tbody>
                        {admissionNo.length > 0 ? (() => {
                          const studentSubjects = studentData.filter(
                            (item) => item.admission_no === admissionNo && item.type === "Academic"
                          );
                          // Calculate maxMarks and marksObtained
                          const maxMarks = studentSubjects.length * 100; // Assuming each subject is out of 100
                          const marksObtained = studentSubjects.reduce(
                            (sum, item) => sum + (item.total_score || 0),
                            0
                          );
                          const percentage = maxMarks > 0 ? ((marksObtained / maxMarks) * 100).toFixed(2) : 0;

                          return (
                            <>
                              {studentSubjects.map((item: any, idx: number) => (
                                <tr key={idx}>
                                  <td>{item?.subject}</td>
                                  <td>{item?.total_score}</td>
                                  <td>{item?.grade}</td>
                                  <td className="text-end">
                                    <span className="badge badge-soft-success d-inline-flex align-items-center">
                                      <i className="ti ti-circle-filled fs-5 me-1" />
                                      {item.remark}
                                    </span>
                                  </td>
                                </tr>
                              ))}
                              <tr>
                                <td className="bg-dark text-white" colSpan={4}>
                                  <div className="d-flex align-items-center justify-content-between">
                                    <span>Rank: N/A</span>
                                    <span>Total Marks: {maxMarks}</span>
                                    <span>Marks Obtained: {marksObtained}</span>
                                    <span>Percentage: {percentage}%</span>
                                    <h6 className="fw-normal text-white">
                                      Result:{" "}
                                      <span className={Number(percentage) >= 40 ? "text-success" : "text-danger"}>
                                        {Number(percentage) >= 40 ? "Pass" : "Fail"}
                                      </span>
                                    </h6>
                                  </div>
                                </td>
                              </tr>
                            </>
                          );
                        })() : (
                          <tr>
                            <td colSpan={4} className="text-center">
                              No subjects available for this exam type.
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>


                  </div>

                  <div className="table-responsive">
                    <table className="table">
                      <thead className="thead-light">
                        <tr>
                          <th className="text-end">Description</th>
                          <th>Grade</th>
                        </tr>
                      </thead>
                      <tbody>
                        {admissionNo.length > 0 ? (
                          (() => {
                            const studentSubjects = studentData.filter(
                              (item) => item.admission_no === admissionNo && item.type === "Behavioral"
                            );
                            if (studentSubjects.length > 0) {
                              // Render existing behavioral subjects for the student
                              return studentSubjects.map((item: any, idx: number) => (
                                <tr key={idx}>
                                  <td>{item?.subject}</td>
                                  <td className="text-end">
                                    <span className="badge badge-soft-success d-inline-flex align-items-center">
                                      <i className="ti ti-circle-filled fs-5 me-1" />
                                      {item.grade}
                                    </span>
                                  </td>
                                </tr>
                              ));
                            } else {
                              // No behavioral subjects found
                              if (showForm) {
                                // If the form is open, render the input fields for each trait along with a Submit button
                                return (
                                  <>
                                    {behavioralTraits?.map((item: any) => (
                                      <tr key={item.description}>
                                        <td className="text-end">{item.description}</td>
                                        <td>
                                          <CommonSelect
                                            defaultValue={
                                              selectedGrades[item.description] || {
                                                label: behavioralForm.grade,
                                                value: behavioralForm.grade,
                                              }
                                            }
                                            handleChange={(newValue: SingleValue<Option>) => {
                                              // Update the controlled select state
                                              setSelectedGrades((prev) => ({
                                                ...prev,
                                                [item.description]: newValue,
                                              }));

                                              // Create the updated entry for this trait
                                              const updatedEntry = {
                                                ...behavioralForm,
                                                grade: newValue ? newValue.value : "",
                                                admission_no: admissionNo,
                                                description: item.description,
                                                category: item.category,
                                              };

                                              // Update the behavioralData array: update existing or append new entry
                                              setBehavioralData((prev) => {
                                                const index = prev.findIndex(
                                                  (entry) => entry.description === item.description
                                                );
                                                if (index !== -1) {
                                                  const updatedData = [...prev];
                                                  updatedData[index] = updatedEntry;
                                                  return updatedData;
                                                }
                                                return [...prev, updatedEntry];
                                              });
                                            }}
                                            options={["A", "B", "C", "D", "E"].map((grade: string) => ({
                                              value: grade,
                                              label: grade,
                                            }))}
                                          />
                                        </td>
                                      </tr>
                                    ))}
                                    <tr>
                                      <td></td>
                                      <td className="text-end">
                                        <Button color="primary" onClick={handleSubmitTrait}>
                                          Submit
                                        </Button>
                                      </td>
                                    </tr>
                                  </>
                                );
                              } else {
                                // If the form is not open, show a button to add a behavioral trait
                                return (
                                  <tr>
                                    <td colSpan={2} className="text-center">
                                      <Button onClick={() => setShowForm(true)}>
                                        Add Behavioral Trait
                                      </Button>
                                    </td>
                                  </tr>
                                );
                              }
                            }
                          })()
                        ) : (
                          // When no admissionNo is provided, render an empty row
                          <tr>
                            <td colSpan={2} className="text-center"></td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );

};

export default GenerateReport;
